export default "__VITE_ASSET__CCp9DYzv__"